import React from 'react';
import PropTypes from 'prop-types';

class TestLayout extends React.PureComponent {
  render() {
    const { children } = this.props;
    return children;
  }
}

TestLayout.defaultProps = {
  children: null
};

TestLayout.propTypes = {
  children: PropTypes.element
};

export default TestLayout;



// WEBPACK FOOTER //
// ./app/layouts/TestLayout.js